/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import TrustedDevice from "./trusted_device/trusted_device";
import TwoStepVerification from "./two_step_verification/two_step_verification";

function TwoStep(props) {

    return (
        <section className="page-body">
            <div className="page-content page-content--security-two-step">
                <TwoStepVerification />

                <TrustedDevice />
            </div>
        </section>
    );
}

export default TwoStep;